module.exports = __webpack_public_path__ + "static/media/main.f92c20be.png";